import { Box, GenericSuspense, Menu, RightSidebar, useUrlParamsValueToString } from "@bsm/component";
import { Outlet, useNavigate } from "react-router-dom";
import { useInvoiceViewerMenu } from "../hooks/useInvoiceViewerMenu";

export const InvoiceGroupViewerContainer = () => {

    const tab = location.pathname.split("/").at(-1);
    const invoiceViewerMenuItems = useInvoiceViewerMenu()
    const urlParamsValueString = useUrlParamsValueToString()
    const navigate = useNavigate()

    const closeViewer = () => {
        navigate(`..?${urlParamsValueString}`)
    }

    return (
        <RightSidebar className={`right-sidebar-absolute p-0`} onClose={closeViewer}>
            <Box title="Parameters" className="h-[max-content] min-h-[100%] flex flex-col gap-[36px]">
                <div className="flex flex-col justify-center gap-4">
                    <Menu
                        items={invoiceViewerMenuItems}
                        type="HORIZONTAL"
                        className="menu-tabs"
                        activeFn={(menu) => menu.ke === tab}
                    />

                    <GenericSuspense>
                        <Outlet />
                    </GenericSuspense>
                </div>
            </Box>
        </RightSidebar>
    );
};